import { CURRENCIES_FILED } from "@/constants/currency";

export function formatCurrency(amount, currency) {
  const numericAmount = parseFloat(amount);
  if (amount == null || Number.isNaN(numericAmount)) {
    return "—";
  }

  const currencyData = CURRENCIES_FILED[currency];

  const formattedAmount = parseFloat(
    numericAmount.toFixed(2)
  ).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (!currencyData) {
    return parseFloat(amount) <= 0
      ? "Free"
      : `${formattedAmount} ${currency || ""}`;
  }

  if (currencyData.prefix) {
    return parseFloat(amount) <= 0
      ? "FREE"
      : `${currencyData.symbol} ${formattedAmount}`;
  } else if (currencyData.postfix) {
    return parseFloat(amount) <= 0
      ? "FREE"
      : `${formattedAmount} ${currencyData.symbol}`;
  }

  return parseFloat(amount) <= 0 ? "Free" : formattedAmount;
}
